import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AIConfig } from '../../models/ai-config.interface';

@Component({
  selector: 'app-ai-button',
  templateUrl: './ai-button.component.html',
  styleUrls: ['./ai-button.component.less'],
})
export class AIButtonComponent {
  @Input() config: AIConfig;
  @Output() buttonClick = new EventEmitter<void>();

  onClick(): void {
    this.buttonClick.emit();
  }
}
